import * as _ from 'lodash';
import * as BillingRate from '@/constants/billing-rate';
import * as ChargeTypes from '@/constants/charge-types';
import * as BillingTypes from '@/constants/billing-payment-type';
import { getCurrentHoursAndMinutes } from '@/common/utils/dates';

export const STEPS = [
    'Details',
    'Dates & Times',
    'Days',
    'Fees & Addons'
];

export const DEFAULT_STATE_MULTI_DAY_DISCOUNT = {
    twoDaysAmount: null,
    threeDaysAmount: null,
    fourDaysAmount: null,
    fiveDaysAmount: null,
    sixDaysAmount: null,
    sevenDaysAmount: null,
    active: false
};

export const DEFAULT_STATE_MULTI_CHILD_DISCOUNT = {
    twoChildrenAmount: null,
    threeChildrenAmount: null,
    fourChildrenAmount: null,
    fiveChildrenAmount: null,
    sixChildrenAmount: null,
    sevenChildrenAmount: null,
    active: false
};

export const DEFAULT_STATE = {
    aftercareName: null,
    locationId: 0,
    ageFrom: null,
    ageTo: null,
    gradeFrom: null,
    gradeTo: null,
    description: null,
    formIds: [],
    aftercareStartDate: null,
    aftercareEndDate: null,
    noAftercareDates: [],
    signUpBeginsDate: new Date(),
    signUpEndsDate: null,
    signUpBeginsTime: getCurrentHoursAndMinutes(),
    signUpEndsTime: '18:00',
    days: [],
    price: 0,
    billingRate: BillingRate.DAY,
    billingType: BillingTypes.SESSION,
    chargeType: ChargeTypes.SCHEDULED,
    dropInPrice: 0,
    dropInBillingRate: BillingRate.DAY,
    prorate: false,
    addOns: [],
    pickUpOptions: false,
    pickUpOptionsRequired: false,
    teacher: false,
    teacherRequired: false,
    tshirt: false,
    tshirtRequired: false,
    multiChildDiscount: _.clone(DEFAULT_STATE_MULTI_CHILD_DISCOUNT),
    multiDayDiscount: _.clone(DEFAULT_STATE_MULTI_DAY_DISCOUNT)
};


// WEBPACK FOOTER //
// ./src/store/modules/aftercare-form/default-state.js